import CircleIcon from '@mui/icons-material/Circle';
import {Box, Card, CardContent, Typography} from '@mui/material';
import * as React from 'react';

const CardWithTitleBlock = ({title, width, variant = false, sx = {}, children}) => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                width: width,
                marginBottom: '1rem',
                ...sx,
            }}
        >
            <Card
                raised={false}
                elevation={0}
                sx={(theme) => ({...cardStyle(theme), ...(variant ? borderVariant(theme) : borderPrimary(theme))})}
            >
                <Box
                    sx={(theme) => ({
                        ...cardTitleBox(theme),
                        ...(variant ? titleVariantStyle(theme) : titlePrimaryStyle(theme)),
                    })}
                >
                    <Box sx={cardTitleSubBox}>
                        <Typography component="div" variant="body2" sx={{paddingTop: '2px', fontWeight: 700}}>
                            {title.toUpperCase()}
                        </Typography>
                        <CircleIcon
                            sx={(theme) => ({
                                ...iconStyle(),
                                ...(variant ? iconVariantStyle(theme) : iconPrimaryStyle(theme)),
                            })}
                        />
                    </Box>
                </Box>
                <CardContent sx={cardContentStyle}>{children}</CardContent>
            </Card>
        </Box>
    );
};

export default CardWithTitleBlock;

const cardStyle = (theme) => ({
    height: '100%',
    width: '100%',
    pt: 2,
    mt: 2,
});

const borderPrimary = (theme) => ({
    border: `2px solid ${theme.palette.primary.main}`,
});

const borderVariant = (theme) => ({
    border: `2px solid ${theme.palette.process_black.light}`,
});

const cardTitleBox = (theme) => ({
    borderRadius: 3,
    position: 'absolute',
    top: '2px',
    left: '-2px',
    height: 30,
    textAlign: 'center',
    outline: '.6rem solid white',
});

const cardTitleSubBox = () => ({
    marginLeft: '1rem',
    marginRight: '.5rem',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
});

const cardContentStyle = (theme) => ({
    px: 3,
    pt: 1,
    pb: theme.spacing(2) + '!important',
    height: '100%',
});

const titlePrimaryStyle = (theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: 'none',
});

const titleVariantStyle = (theme) => ({
    backgroundColor: theme.palette.process_black.contrastText,
    color: theme.palette.process_black.light,
    border: `2px solid ${theme.palette.process_black.light}`,
});

const iconStyle = () => ({
    marginLeft: '.5rem',
    fontSize: '.6rem',
});

const iconPrimaryStyle = (theme) => ({
    color: theme.palette.primary.contrastText,
});

const iconVariantStyle = (theme) => ({
    color: theme.palette.primary.main,
});
